import { newTracker, addGlobalContexts } from '@snowplow/browser-tracker'
import { overrideTrackerIDs, initExperimentsGlobalContextTracker } from 'analytics/snowplow'
import { APP_CONTEXT_SCHEMA } from 'constants/analytics'
import config from 'constants/config'
import { getCookies, deleteCookie } from 'lib/cookies'

function initAppsFlyer() {
  import(/* webpackChunkName: "AppsflyerCapacitorPlugin" */ 'appsflyer-capacitor-plugin')
    .then(appsFlyerModule => {
      const { AppsFlyer } = appsFlyerModule

      const afConfig = {
        appID: config.MOBILE_APP_AF_APP_ID,
        devKey: config.MOBILE_APP_AF_DEV_KEY,
        isDebug: config.MOBILE_APP_AF_DEBUG,
        waitForATTUserAuthorization: 10, // for iOS 14 and higher
        registerOnDeepLink: true,
        registerConversionListener: true,
        registerOnAppOpenAttribution: false,
        useReceiptValidationSandbox: true, // iOS only
        useUninstallSandbox: true, // iOS only
      }

      AppsFlyer.initSDK(afConfig)
        .catch(e => {
          console.error('Error in AppFlyer Initialization', e)
        })
    },
    )
    .catch(e => {
      console.error('Error importing AppsFlyer module', e)
    })
}

function initialiseAnalytics() {
  if (config.TRACKING_HOST) {
    const tracker = newTracker('sp', config.TRACKING_HOST, {
      // MOBILE_APP_PLATFORM value (ios/android) will be passed only for the WL-Mobile build
      appId: config.MOBILE_APP_PLATFORM ? config.wlMobileApp[config.MOBILE_APP_PLATFORM].snowPlow.appId : config.snowPlow.appId,
      plugins: [],
      // you must specify the path since the default path
      // /com.snowplowanalytics.snowplow/tp2 will be blocked by adblock
      postPath: '/com.luxgroup/tp2',
      // not-encoding the data makes debugging easier
      encodeBase64: false,
    })

    try {
      const domainUserIdKey = 'lux_sp_domain_user_id'
      const sessionIdKey = 'lux_sp_session_id'
      const sessionIdxKey = 'lux_sp_session_idx'
      const dict = getCookies()
      // If a user came from mobile webview,
      // we will override the domain ID, session ID and session IDX with
      // values that come from the mobile webview.
      if (dict[domainUserIdKey] || dict[sessionIdKey] || dict[sessionIdxKey]) {
        try {
          overrideTrackerIDs(
            tracker,
            dict[sessionIdKey],
            dict[domainUserIdKey],
            Number.isFinite(dict[sessionIdxKey]) ? Number(dict[sessionIdxKey]) : undefined,
          )
        } catch (e) {
          reportError(e)
        }

        deleteCookie(domainUserIdKey)
        deleteCookie(sessionIdxKey)
        deleteCookie(sessionIdKey)
      }
    } catch {
      // ignore
    }

    addGlobalContexts([{
      schema: APP_CONTEXT_SCHEMA,
      data: {
        appVersion: config.commitSha || '-',
      },
    }])
    initExperimentsGlobalContextTracker()

    // WL-Mobile AppsFlyer initialization
    if (config.MOBILE_APP_CUSTOMISATIONS) {
      initAppsFlyer()
    }
  }
}

export default initialiseAnalytics
